interface Props {
	brandTitle: string | undefined;
	model: string | undefined;
}

export default function ProductPopoverSubtitle({ brandTitle, model }: Props) {
	const subheading = model ? (
		<>
			{brandTitle}
			<span className="sr-only">, </span>
			<span aria-hidden>{' | '}</span>
			{model}
		</>
	) : (
		brandTitle
	);
	return <p>{subheading}</p>;
}
ProductPopoverSubtitle.displayName = 'ProductPopoverSubtitle';
